import { fieldDef } from '../../guidance/roleFieldRegistry';

export type StepKey = 'start' | 'details' | 'responsibilities' | 'qualifications' | 'compensation' | 'review';

export const STEP_LABEL: Record<StepKey, string> = {
  start: 'Start', details: 'Role details', responsibilities: 'Responsibilities', qualifications: 'Qualifications', compensation: 'Compensation (optional)', review: 'Review',
};

const BY_NUMBER: Record<number, StepKey> = { 1: 'start', 2: 'details', 3: 'responsibilities', 4: 'qualifications', 5: 'compensation', 6: 'review' };

/** The step that owns a field, read from the registry (so a field moved to another step moves its links too). */
export function stepOfField(key: string): StepKey {
  try {
    return BY_NUMBER[fieldDef(key).step] ?? 'details';
  } catch {
    return 'details';
  }
}
